import { render, staticRenderFns } from "./BomViewer.vue?vue&type=template&id=3d094508&scoped=true"
import script from "./BomViewer.vue?vue&type=script&lang=js"
export * from "./BomViewer.vue?vue&type=script&lang=js"
import style0 from "./BomViewer.vue?vue&type=style&index=0&id=3d094508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d094508",
  null
  
)

export default component.exports